import { Injectable } from '@angular/core';

@Injectable()
export class PressKitCardWrapperService {
  // State is preserved PER press kit for its articles card wrapper being opened or not
  private _isCardWrapperOpenedObj: { [key: string]: boolean } = {};

  public setIsCardWrapperOpened(pressKitId: string, isCardWrapperOpened: boolean): void {
    this._isCardWrapperOpenedObj[pressKitId] = isCardWrapperOpened;
  }

  public isCardWrapperOpened(pressKitId: string): boolean {
    return this._isCardWrapperOpenedObj[pressKitId] ?? false;
  }
}
